import ebgLogo from './assets/ebg/ebg.png';
import sgkLogo from './assets/Logos/sgk_vobis.svg';
import nhgLogo from './assets/nhg/NHG_Kundenportal_MAX w LOGO_1000x620.png';

type Configuration = {
  [key: string]: {
    color: string;
    title: string;
    logo: string;
    hasReservations: boolean;
    linkToNewsPage: string;
    hba_ids: string[];
    bookingLink?: string;
    name: string;
  };
};

const Config: Configuration = {
  wbg: {
    color: '#ea2210',
    title: 'Willkommen im Kundenportal der Wohnbaugruppe Ennstal',
    hasReservations: true,
    logo: ebgLogo,
    linkToNewsPage: 'https://www.wohnbaugruppe.at/kundenportal-newspage/',
    hba_ids: ['1', '10', '12', '13', '14'],
    name: 'Wohnbaugruppe Ennstal',
  },
  ebg: {
    color: '#d20040',
    title: 'Willkommen im Kundenportal der EBG',
    logo: ebgLogo,
    hasReservations: false,
    linkToNewsPage: 'https://www.ebg-wohnen.at/die-ebg/neuigkeiten',
    hba_ids: ['4', '41', '67'],
    bookingLink: 'https://buchen.ebg-wohnen.at',
    name: 'EBG',
  },
  'ebg-staging': {
    color: '#d20040',
    title: 'Willkommen im Kundenportal TEST der EBG',
    logo: ebgLogo,
    hasReservations: false,
    linkToNewsPage: 'https://www.ebg-wohnen.at/die-ebg/neuigkeiten',
    hba_ids: ['4', '41', '67'],
    bookingLink: 'https://buchen.ebg-wohnen.at',
    name: 'EBG TEST',
  },
  sgk: {
    color: '#70ac48',
    title: 'Willkommen auf der Serviceplattform der SGK und VOBIS',
    hasReservations: false,
    logo: sgkLogo,
    linkToNewsPage: 'https://www.sgk.at/aktuelles',
    hba_ids: ['1', '10', '12', '13', '14', '16'],
    name: 'SGK und VOBIS',
  },
  gwg: {
    color: '#a8c76a',
    title: 'Die Auftragsplattform der GWG',
    logo: ebgLogo,
    hasReservations: true,
    linkToNewsPage: 'https://www.gwg-linz.at/neuigkeiten-und-presse/',
    hba_ids: ['1', '10', '12', '13', '14'],
    name: 'GWG',
  },
  nhg: {
    color: '#004f9e',
    title: 'Willkommen im Kundenportal Neue Heimat Gewog',
    logo: nhgLogo,
    hasReservations: false,
    linkToNewsPage: 'https://www.nhg.at/kundenservice/aktuelles/',
    hba_ids: ['1', '10', '12', '13', '14'],
    name: 'NHG',
  },
  sgl: {
    color: '#f20000',
    title: 'Kundenportal der Leoben Wohnbau',
    logo: ebgLogo,
    hasReservations: true,
    linkToNewsPage: 'https://www.wohnbau-leoben.at/news/',
    hba_ids: ['1', '10', '12', '13', '14'],
    name: 'Leoben Wohnbau',
  },
};

export default Config;
